import { render, staticRenderFns } from "./subscribePannel.vue?vue&type=template&id=64d141e0"
import script from "./subscribePannel.vue?vue&type=script&lang=js"
export * from "./subscribePannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports